import { combineReducers } from 'redux';
import { loadingBarReducer as loadingBar } from 'react-redux-loading-bar';

import locale, { LocaleState } from './locale';
import authentication, { AuthenticationState } from './authentication';
import applicationProfile, { ApplicationProfileState } from './application-profile';

import administration, { AdministrationState } from 'app/modules/administration/administration.reducer';
import userInfo, { UserInfoState } from 'app/modules/account/user/user.reducer';
import register, { RegisterState } from 'app/modules/account/register/register.reducer';
import approveManagement, { ApproveManagementState } from 'app/modules/administration/approve-management/approve-management.reducer';
import activate, { ActivateState } from 'app/modules/account/activate/activate.reducer';
import password, { PasswordState } from 'app/modules/account/password/password.reducer';
import passwordReg, { PasswordRegState } from 'app/modules/account/password-reg/password.reducer';
import passwordSet, { PasswordSetState } from 'app/modules/account/password-set/password.reducer';
import settings, { SettingsState } from 'app/modules/account/settings/settings.reducer';
import passwordReset, { PasswordResetState } from 'app/modules/account/password-reset/password-reset.reducer';
import sendotp, { SendOtpState } from 'app/modules/sendOtp/sendOtp.reducer';
import adminManager, { AdminManagerState } from '../../shared/layout/menus/ManagerIdentifier/admin-reducers';
import historyManager, { HistorymanagerState } from 'app/shared/layout/menus/history/history-reducers';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

export interface IRootState {
  readonly authentication: AuthenticationState;
  readonly locale: LocaleState;
  readonly applicationProfile: ApplicationProfileState;
  readonly administration: AdministrationState;
  readonly userInfo: UserInfoState;
  readonly register: RegisterState;
  readonly approveManagement: ApproveManagementState;
  readonly activate: ActivateState;
  readonly passwordReset: PasswordResetState;
  readonly password: PasswordState;
  readonly passwordReg: PasswordRegState;
  readonly passwordSet: PasswordSetState;
  readonly settings: SettingsState;
  readonly sendotp: SendOtpState;
  readonly adminManager: AdminManagerState;
  readonly historyManager: HistorymanagerState;
  /* jhipster-needle-add-reducer-type - JHipster will add reducer type here */
  readonly loadingBar: any;
}

const rootReducer = combineReducers<IRootState>({
  authentication,
  locale,
  applicationProfile,
  administration,
  userInfo,
  register,
  approveManagement,
  activate,
  passwordReset,
  password,
  passwordReg,
  settings,
  sendotp,
  adminManager,
  passwordSet,
  historyManager,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
  loadingBar
});

export default rootReducer;
